<template>
  <b-form-group
    :label="label"
    :label-size="size"
    :label-class="`font-weight-bold ${(validate.required === true || (typeof validate === 'string' && validate.search('required') !== -1) ? 'is-required' : '')}`"
    v-slot="{ ariaDescribedby }"
  >
    <ValidationProvider
      v-slot="validationContext"
      ref="inputValidation"
      :rules="validate"
      :mode="validationMode"
      :name="name"
    >
      <b-form-radio-group
        v-model="_value"
        :aria-describedby="ariaDescribedby"
        :options="options"
        :state="getValidationState(validationContext)"
        @change="onchange"
        >
      </b-form-radio-group>
      <b-form-invalid-feedback
        :state="validationContext.errors.length === 0"
      >
        {{ validationContext.errors.join('. ') }}
      </b-form-invalid-feedback>
    </ValidationProvider>
  </b-form-group>
</template>

<script>
  export default {
    name: 'InputRadioComponent',
    props: {
      name: {
        type: String,
        required: true,
      },
      label: {
        type: String,
        required: false,
        default: ''
      },
      options: {
        type: Array,
        required: true,
        default: () => []
      },
      onchange: {
        type: Function,
        required: false,
        default: () => {}
      },
      validate: {
        type: [String, Object],
        required: false,
        default: ''
      },
      size: {
        type: String,
        required: false,
        default: ''
      },
      value: {
        type: [String, Number],
        required: false,
        default: null,
      },
      validationMode: {
        type: String,
        required: false,
        default: 'passive'
      }
    },
    computed: {
      _value: {
        get () {
          // setTimeout(() => {
          //   this.$refs['inputValidation'].validate()
          // }, 300)
          return this.value
        },
        set (value) {
          this.$emit('update:value', value)
          this.$emit('input', value)
        }
      }
    },
    methods: {
      getValidationState({ validated, valid = null}) {
        return validated ? valid : null
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>